<script lang="ts" setup>
const formData = ref({
  firstName: '',
  lastName: '',
  telephoneNo: '',
  emailAddress: '',
  location: '',
  organisation: '',
  message: '',
})
</script>

<template>
  <div class="flex bg-primary flex-wrap">
    <div class="w-full py-24 2xl:w-auto bg-primary flex-1 flex items-center justify-center text-2xl md:text-3xl lg:text-4xl text-white relative overflow-clip px-6">
      We would love to hear from you.
      <img
        src="/icon.svg"
        class="absolute -bottom-24 -right-64 z-3 w-1/3 h-auto"
      >
      <img
        src="/icon.svg"
        class="absolute -top-12 rotate-90 -left-24 z-3 w-1/8 h-auto"
      >
    </div>
    <FormContainer
      v-model="formData"
      api-route="/api/send-mail"
      class="xl:max-w-4xl mx-auto p-10 w-full xl:flex-1 bg-zinc-200 lg:my-32 rounded-xl xl:rounded-r-none xl:rounded-l-xl"
    >
      <div class="flex flex-col gap-2">
        <label for="name">
          Name:<span class="text-primary">*</span></label>
        <input
          id="name"
          v-model="formData.firstName"
          required
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
          type="text"
        >
      </div>

      <div class="flex flex-col gap-2">
        <label for="telephoneNo">
          Telephone No.:</label>
        <input
          id="telephoneNo"
          v-model="formData.telephoneNo"
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
          type="tel"
        >
      </div>
      <div class="flex flex-col gap-2">
        <label for="emailAddress">
          Email Address:<span class="text-primary">*</span></label>
        <input
          id="emailAddress"
          v-model="formData.emailAddress"
          required
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
          type="email"
        >
      </div>
      <!-- <div class="flex flex-col gap-2">
        <label for="location">
          Location:<span class="text-primary">*</span></label>
        <input
          id="location"
          v-model="formData.location"
          required
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
          type="text"
        >
      </div>
      <div class="flex flex-col gap-2">
        <label for="organisation">
          Organisation:<span class="text-primary">*</span></label>
        <input
          id="organisation"
          v-model="formData.organisation"
          required
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
          type="text"
        >
      </div> -->
      <div class="flex flex-col gap-2">
        <label for="message">
          Message:<span class="text-primary">*</span></label>
        <textarea
          id="message"
          v-model="formData.message"
          required
          class="border-b border-b-primary px-3 py-2 bg-white/10 focus:ring-primary-dark focus:bg-transparent focus:outline-none focus:ring-2"
        />
      </div>
    </FormContainer>
  </div>
</template>
